import {Inject, Injectable, Optional, PLATFORM_ID} from "@angular/core";
import {isPlatformBrowser} from "@angular/common";
import {REQUEST} from "@nguniversal/express-engine/tokens";
import {classifyUserAgent} from "../constants/user-agent";

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  // window.innerWidth doesn't exist during SSR, so without this the server always rendered as
  // desktop regardless of the real device — the client-side check below only takes over once the
  // bundle hydrates, which showed up as mobile users briefly (or, on a slow connection, not so
  // briefly) seeing the desktop layout. ngExpressEngine auto-provides REQUEST (see server.ts,
  // which passes `req` into res.render) so we can read the real User-Agent server-side instead.
  private ssrIsMobile = false;
  private ssrIsTablet = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    @Optional() @Inject(REQUEST) request?: any,
  ) {
    if (!isPlatformBrowser(this.platformId) && request) {
      const ua: string = request.headers?.['user-agent'] || '';
      const deviceType = classifyUserAgent(ua);
      this.ssrIsTablet = deviceType === 'tablet';
      this.ssrIsMobile = deviceType === 'mobile';
    }
  }

  isMobile() {
    if (isPlatformBrowser(this.platformId)) {
      const width = window.innerWidth;
      return width <= 768;
    }
    return this.ssrIsMobile;
  }

  isTablet() {
    if (isPlatformBrowser(this.platformId)) {
      const width = window.innerWidth;
      return width > 768 && width <= 1024;
    }
    return this.ssrIsTablet;
  }

  isDesktop() {
    if (isPlatformBrowser(this.platformId)) {
      const width = window.innerWidth;
      return width > 1024;
    }
    return !this.ssrIsMobile && !this.ssrIsTablet;
  }
}
